<template>
    <div class="row justify-content-center advertising-visuals mt-5">
        <template v-if="isBuilt">
            <h1 class="section-name col-12 mb-4 text-uppercase">{{advertisingVisualsData.name}}</h1>
            <div v-if="showQueries" v-html="this.query">{{ this.query }}</div>
            <template v-if="!!missed_accounts.length && !use_ad_lib">
                <div class="col-12">
                    <div v-for="missed_account in missed_accounts" class="missed-accounts my-3">There are no accounts connected for {{missed_account}}. Either connect an account or change the metrics/remove this section in the builder.</div>
                </div>
            </template>
            <div v-if="reloading" class="spinner element-spinner d-flex flex-column justify-content-center align-items-center">
                <span class="spinner-border spinner-border-sm margin-right5" role="status" aria-hidden="true"></span>
            </div>
            <!--<div class="col d-flex justify-content-between align-items-start flex-wrap">-->
            <div class="text-center">
                <div v-if="!has_data && !reloading" class="nodata-container p-5 text-center">
                    <div v-if="errors" class="empty-data"><img :src="$store.state.app_url+'/images/errors.gif'"></div>
                    <div v-else class="empty-data"><img :src="$store.state.app_url+'/images/nodata.svg'"></div>
                </div>
                <template v-if="use_ad_lib">
                    <div class="d-flex flex-wrap justify-content-center">
                        <div v-for="visual in visuals" class="ad-lib" :class="'num-visuals-'+visuals.length">
                            <img :src="`data:${visual.image_mime_type};base64,${visual.image_data}`">
                        </div>
                    </div>
                </template>
                <template v-else>
                    <template v-for="visual in visuals">
                        <template v-if="visual.ad_type == 'IMAGE_AD'">
                            <img  class="grid-item mx-1 my-1" :src="visual.image_url" :width="resize_ads(visual.w)" :height="resize_ads(visual.h)" />
                        </template>
                        <template v-else>
                            <iframe  class="grid-item mx-1 my-1 border-0" :src="visual.image_url" :width="visual.w" :height="visual.h"></iframe>
                        </template>
                    </template>
                </template>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        props: ['isBuilt', 'hasSkb', 'advertisingVisualsData'],
        created() {
            if(this.isBuilt){
                this.num_visuals = this.advertisingVisualsData.element_configurations.num_visuals;
                this.use_ad_lib = this.advertisingVisualsData.element_configurations.use_ad_lib;
                this.ad_type = this.use_ad_lib && !!this.advertisingVisualsData.extra_data ? this.advertisingVisualsData.extra_data.ad_type : null;
                this.ads_size = !!this.advertisingVisualsData.element_configurations.ads_size ? this.advertisingVisualsData.element_configurations.ads_size.slice(0, -1) : null;
                event_bus.$on('current_dwm', () => {
                    this.current_dwm = this.$store.state.current_dwm;
                    event_bus.$emit('reloading', true);
                });
                this.fetchServerData();
                this.missed_accounts = this.checkAccounts(this.advertisingVisualsData);
            }
        },
        data() {
            return {
                visuals:[],
                num_visuals:null,
                has_data:null,
                missed_accounts:[],
                use_ad_lib:null,
                ad_type:null,
                ads_size:null,
                errors:false,
                query:'',
                showQueries:    this.$store.state.showQueries,
                reloading:true
            }
        },
        mounted() {
            event_bus.$on('reloading', () => {
                this.reloading = true;
                this.fetchServerData();
            });
        },
        methods: {
            fetchServerData(){
                const params = {
                    'isArchive':this.isArchive,
                    'prefixed_id': this.advertisingVisualsData.report_id,
                    'element_abbr':this.advertisingVisualsData.element_abbreviation,
                    'dwm':this.$store.state.current_dwm,
                    'dates':this.$store.state.current_dates,
                    'element_id': this.advertisingVisualsData.element_id,
                    'prefixed_element_id': this.advertisingVisualsData.report_element_id,
                    'element_name': this.advertisingVisualsData.name,
                    'metrics': this.advertisingVisualsData.metrics,
                    'segment': this.advertisingVisualsData.segment,
                    'accounts': this.advertisingVisualsData.accounts,
                    'num_visuals':this.num_visuals,
                    'use_ad_lib':this.use_ad_lib,
                    'ad_type':this.ad_type,
                    'client_id':this.advertisingVisualsData.client_id,
                    'showQueries':this.showQueries,
                    'hasSkb':this.hasSkb,
                };
                axios.post('/api/reporting/element', params).then((response) => {
                    this.visuals = response.data.visuals;
                    this.query = response.data.query;
                    this.errors = response.data.errors;
                    this.has_data = response.data.has_data;
                    this.reloading = false;
                });
            },
            resize_ads(size){
                if(!!this.ads_size && this.ads_size != 100){
                    return size*(this.ads_size/100);
                }
                return size;
            }
        }
    }
</script>
<style lang="scss">
    @import '~@/_variables.scss';
    .advertising-visuals{
        iframe{
            vertical-align: top;
        }
        div.nodata-container{
            background-color:white;
        }
        div.advert-wrap{
            img{
                max-width:100%;
            }
        }
        h1.advertising-title{
            font-size:5rem;
        }
        img {
            vertical-align: top;
        }
        div.ad-lib{
            max-width:30%;
            margin:0 auto;
            margin-bottom:2rem;
            img{
                max-width:100%;
            }
            &.num-visuals-1, &.num-visuals-2{
                max-width:50%;
            }
        }
    }
</style>
